import CompareCard from "./CompareCard";
import ProjectSelector from "./ProjectSelector";
import FinalTotals from "./FinalTotals";
import { useState, useEffect } from "react";
import { data } from "./data";

function ProductCalculator() {
	const [labor, setLabor] = useState(30);
	const [sqFeet, setSqFeet] = useState(1000);
	const [project, setProject] = useState(0);
	const [project2, setProject2] = useState(1);
	const [warrantyOption, setWarrantyOption] = useState(0);

	const [MVISproductData, setMVISProductData] = useState(data[project]);
	const [LATHproductData, setLATHProductData] = useState(data[project2]);

	return (
		<div className="product_calculator">
			<ProjectSelector
				labor={labor}
				setLabor={setLabor}
				sqFeet={sqFeet}
				setSqFeet={setSqFeet}
				project={project}
				setProject={setProject}
				setProject2={setProject2}
			/>
			<div className="card-holder">
				<div className="row content card-row">
					<div className="col-xl-6 card-col card-white">
						<div className="recommendation-box col-sm-5">
							Our Recommendation
						</div>
						<CompareCard
							productData={MVISproductData}
							setProductData={setMVISProductData}
							project={project}
							labor={labor}
							warrantyOption={warrantyOption}
							setWarrantyOption={setWarrantyOption}
						/>
					</div>
					<div className="col-xl-6  card-col card card-gray">
						<CompareCard
							productData={LATHproductData}
							setProductData={setLATHProductData}
							project={project2}
							labor={labor}
							warrantyOption={warrantyOption}
							setWarrantyOption={setWarrantyOption}
						/>
					</div>
				</div>
			</div>
			<FinalTotals
				totalMVIS={MVISproductData.finalTotal}
				totalLATH={LATHproductData.finalTotal}
				sqFeet={sqFeet}
			/>
		</div>
	);
}

export default ProductCalculator;
